/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { BankDetailsDeleteResponseDto } from '../models/BankDetailsDeleteResponseDto';
import type { BankDetailsDto } from '../models/BankDetailsDto';
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { CreateBankDetailsDto } from '../models/CreateBankDetailsDto';
import type { CreateSolicitorWithUserDto } from '../models/CreateSolicitorWithUserDto';
import type { ForgotPasswordRequestDto } from '../models/ForgotPasswordRequestDto';
import type { ForgotPasswordResponseDto } from '../models/ForgotPasswordResponseDto';
import type { PasswordChangeResponseDto } from '../models/PasswordChangeResponseDto';
import type { ResetPasswordDto } from '../models/ResetPasswordDto';
import type { SignedUrlResponseDto } from '../models/SignedUrlResponseDto';
import type { SolicitorDto } from '../models/SolicitorDto';
import type { SolicitorNotificationSettingsDto } from '../models/SolicitorNotificationSettingsDto';
import type { UpdateBankDetailsDto } from '../models/UpdateBankDetailsDto';
import type { UpdateSolicitorNotificationSettingsDto } from '../models/UpdateSolicitorNotificationSettingsDto';
import type { UpdateSolicitorDto } from '../models/UpdateSolicitorDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SolicitorsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create new solicitor entity
     * @param requestBody Data for creating a user
     * @returns SolicitorDto The solicitor has been successfully created.
     * @throws ApiError
     */
    public solicitorsControllerCreate(
        requestBody: CreateSolicitorWithUserDto,
    ): Observable<SolicitorDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/solicitors/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update a solicitor registration and activate the user
     * @param id
     * @param requestBody Data for updating a solicitor
     * @returns any The solicitor has been successfully updated.
     * @throws ApiError
     */
    public solicitorsControllerUpdateSolicitor(
        id: string,
        requestBody: UpdateSolicitorDto,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/solicitors/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a solicitor by ID
     * @param id The UUID of the solicitor
     * @returns SolicitorDto The solicitor details.
     * @throws ApiError
     */
    public solicitorsControllerGetSolicitor(
        id: string,
    ): Observable<SolicitorDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Solicitor not found.`,
            },
        });
    }
    /**
     * Delete a solicitor
     * @param id The UUID of the solicitor to delete
     * @returns void
     * @throws ApiError
     */
    public solicitorsControllerDeleteSolicitor(
        id: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/solicitors/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Solicitor not found.`,
            },
        });
    }
    /**
     * Get approved solicitors for public landing page
     * Returns only approved and active solicitors for public display on landing pages
     * @param page
     * @param limit
     * @param sortActive
     * @param sortDirection
     * @param filter
     * @returns any List of approved solicitors retrieved successfully.
     * @throws ApiError
     */
    public solicitorsControllerGetPublicSolicitors(
        page: number,
        limit: number,
        sortActive: string,
        sortDirection: string,
        filter: string,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors/public',
            query: {
                'page': page,
                'limit': limit,
                'sortActive': sortActive,
                'sortDirection': sortDirection,
                'filter': filter,
            },
        });
    }
    /**
     * Get public signed URL for solicitor logo
     * Returns a temporary signed URL to access the solicitor logo. Public access for approved solicitors.
     * @param id The UUID of the solicitor
     * @returns SignedUrlResponseDto Signed URL generated successfully.
     * @throws ApiError
     */
    public solicitorsControllerGetPublicLogoSignedUrl(
        id: string,
    ): Observable<SignedUrlResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors/public/{id}/logo-url',
            path: {
                'id': id,
            },
            errors: {
                404: `Solicitor or logo not found.`,
            },
        });
    }
    /**
     * Get all solicitors (admin access)
     * Returns all solicitors including unapproved and inactive. Used by admin pages.
     * @param page
     * @param limit
     * @param sortActive
     * @param sortDirection
     * @param filter
     * @param statuses
     * @param roles
     * @returns any List of solicitors retrieved successfully.
     * @throws ApiError
     */
    public solicitorsControllerGetSolicitors(
        page: number,
        limit: number,
        sortActive: string,
        sortDirection: string,
        filter: string,
        statuses: Array<string>,
        roles: Array<string>,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors',
            query: {
                'page': page,
                'limit': limit,
                'sortActive': sortActive,
                'sortDirection': sortDirection,
                'filter': filter,
                'statuses': statuses,
                'roles': roles,
            },
            errors: {
                403: `Access denied.`,
            },
        });
    }
    /**
     * Get solicitor notification settings
     * @param id The UUID of the solicitor
     * @returns SolicitorNotificationSettingsDto Solicitor notification settings retrieved successfully.
     * @throws ApiError
     */
    public solicitorsControllerGetNotificationSettings(
        id: string,
    ): Observable<SolicitorNotificationSettingsDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors/{id}/notification-settings',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update solicitor notification settings
     * @param id The UUID of the solicitor
     * @param requestBody Notification settings for this solicitor branch
     * @returns SolicitorNotificationSettingsDto Solicitor notification settings updated successfully.
     * @throws ApiError
     */
    public solicitorsControllerUpdateNotificationSettings(
        id: string,
        requestBody: UpdateSolicitorNotificationSettingsDto,
    ): Observable<SolicitorNotificationSettingsDto> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/solicitors/{id}/notification-settings',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upload logo for solicitor
     * @param id
     * @param formData Solicitor logo file
     * @returns SolicitorDto Logo uploaded successfully.
     * @throws ApiError
     */
    public solicitorsControllerUploadLogo(
        id: string,
        formData: {
            file?: Blob;
        },
    ): Observable<SolicitorDto> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/solicitors/{id}/logo',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get signed URL for solicitor logo
     * Returns a temporary signed URL to access the solicitor logo. Solicitors can only access their own logo, super admins can access any.
     * @param id The UUID of the solicitor
     * @returns SignedUrlResponseDto Signed URL generated successfully.
     * @throws ApiError
     */
    public solicitorsControllerGetLogoSignedUrl(
        id: string,
    ): Observable<SignedUrlResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors/{id}/logo-url',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Solicitor or logo not found.`,
            },
        });
    }
    /**
     * Change solicitor password
     * Allows solicitors to change their own password or super admins to change any solicitor password.
     * @param id The UUID of the solicitor
     * @param requestBody Password change data
     * @returns PasswordChangeResponseDto Password changed successfully.
     * @throws ApiError
     */
    public solicitorsControllerChangePassword(
        id: string,
        requestBody: ChangePasswordDto,
    ): Observable<PasswordChangeResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/solicitors/{id}/change-password',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid password or validation failed.`,
                403: `Access denied.`,
                404: `Solicitor not found.`,
            },
        });
    }
    /**
     * Request password reset
     * Sends a password reset email to the solicitor if the email exists. Returns a generic message for security.
     * @param requestBody Email address
     * @returns ForgotPasswordResponseDto Password reset email sent (if email exists).
     * @throws ApiError
     */
    public solicitorsControllerForgotPassword(
        requestBody: ForgotPasswordRequestDto,
    ): Observable<ForgotPasswordResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/solicitors/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reset password with token
     * Resets the password using a valid reset token received via email.
     * @param requestBody Reset token and new password
     * @returns PasswordChangeResponseDto Password reset successfully.
     * @throws ApiError
     */
    public solicitorsControllerResetPassword(
        requestBody: ResetPasswordDto,
    ): Observable<PasswordChangeResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/solicitors/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or expired token, or password validation failed.`,
            },
        });
    }
    /**
     * Update solicitor status to INACTIVE
     * Deactivates a solicitor by updating their status from ACTIVE to INACTIVE. Only ACTIVE solicitors can be deactivated.
     * @param id The UUID of the solicitor
     * @returns SolicitorDto Solicitor status updated to INACTIVE successfully.
     * @throws ApiError
     */
    public solicitorsControllerUpdateSolicitorStatusToInactive(
        id: string,
    ): Observable<SolicitorDto> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/solicitors/{id}/status',
            path: {
                'id': id,
            },
            errors: {
                400: `Solicitor is not ACTIVE or invalid status.`,
                403: `Access denied.`,
                404: `Solicitor not found.`,
            },
        });
    }
    /**
     * Create bank account details for solicitor
     * Add bank account information for a solicitor. Sensitive fields (BSB, account number, bank name) are encrypted.
     * @param solicitorId The UUID of the solicitor
     * @param requestBody Bank account details
     * @returns BankDetailsDto Bank details created successfully.
     * @throws ApiError
     */
    public solicitorsControllerCreateBankDetails(
        solicitorId: string,
        requestBody: CreateBankDetailsDto,
    ): Observable<BankDetailsDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/solicitors/{solicitorId}/bank-details',
            path: {
                'solicitorId': solicitorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied.`,
                404: `Solicitor not found.`,
            },
        });
    }
    /**
     * Get all bank accounts for a solicitor
     * Retrieve all bank account details for a solicitor (decrypted for authorized users).
     * @param solicitorId The UUID of the solicitor
     * @returns BankDetailsDto Bank details retrieved successfully.
     * @throws ApiError
     */
    public solicitorsControllerGetAllBankDetailsForSolicitor(
        solicitorId: string,
    ): Observable<Array<BankDetailsDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors/{solicitorId}/bank-details',
            path: {
                'solicitorId': solicitorId,
            },
            errors: {
                403: `Access denied.`,
                404: `Solicitor not found.`,
            },
        });
    }
    /**
     * Update bank account details
     * Update existing bank account information. Sensitive fields are re-encrypted if updated.
     * @param solicitorId The UUID of the solicitor
     * @param id The UUID of the bank details
     * @param requestBody Bank account details to update
     * @returns BankDetailsDto Bank details updated successfully.
     * @throws ApiError
     */
    public solicitorsControllerUpdateBankDetails(
        solicitorId: string,
        id: string,
        requestBody: UpdateBankDetailsDto,
    ): Observable<BankDetailsDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/solicitors/{solicitorId}/bank-details/{id}',
            path: {
                'solicitorId': solicitorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied.`,
                404: `Bank details or solicitor not found.`,
            },
        });
    }
    /**
     * Get single bank account details
     * Retrieve specific bank account details (decrypted for authorized users).
     * @param solicitorId The UUID of the solicitor
     * @param id The UUID of the bank details
     * @returns BankDetailsDto Bank details retrieved successfully.
     * @throws ApiError
     */
    public solicitorsControllerGetBankDetailsById(
        solicitorId: string,
        id: string,
    ): Observable<BankDetailsDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitors/{solicitorId}/bank-details/{id}',
            path: {
                'solicitorId': solicitorId,
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Bank details or solicitor not found.`,
            },
        });
    }
    /**
     * Delete bank account details
     * Remove bank account information from the system.
     * @param solicitorId The UUID of the solicitor
     * @param id The UUID of the bank details
     * @returns BankDetailsDeleteResponseDto Bank details deleted successfully.
     * @throws ApiError
     */
    public solicitorsControllerDeleteBankDetails(
        solicitorId: string,
        id: string,
    ): Observable<BankDetailsDeleteResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/solicitors/{solicitorId}/bank-details/{id}',
            path: {
                'solicitorId': solicitorId,
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Bank details or solicitor not found.`,
            },
        });
    }
}
